// extracted by mini-css-extract-plugin
module.exports = {"items":"SearchResultTextSection_items__oHsUe","link":"SearchResultTextSection_link__JsYqy","linkContainer":"SearchResultTextSection_linkContainer__fLDeV"};